import { createApiCall } from 'lib/base';

const FETCH_INVESTMENT_PLAN_API_ID = 'INVESTCORE/FETCH_INVESTMENT_PLAN_API';

const apiCall = createApiCall(
  FETCH_INVESTMENT_PLAN_API_ID,
  ({ id }) => ({
    endpoint: `/api/admin/employee-programs/${id}/investment-details`,
    method: 'GET',
  })
);

export default apiCall;
